module.exports = __webpack_public_path__ + "static/media/vattenfall.5225f904.png";